import React, { useEffect, useState } from 'react'

import { Grid, RootRef, Button, Divider, useMediaQuery, useTheme } from '@material-ui/core'

import projectPageStyle from "./projectPageStyle.jsx"
import withStyles from "@material-ui/core/styles/withStyles"
import Header from "../../Header/Header"
import Footer from '../../Footer/Footer'
import NewsLetter from '../../NewsLetter/NewsLetter'
import Contact from '../../Contact/Contact'
import ContactProject from '../../Contact/ContactProject'
import GalleryCarousel from '../../Carousel/GalleryCarousel'
import ProjectCard from '../ProjectCard'
import VideoPlayer from '../../Player/VideoPlayer'
import Pagination from '../../Pagination/Pagination'
import { zoneCards } from '../../../constants/NewHomeCard'
import aptType from '../../../constants/ApartmentType.js'
import zones from '../../../constants/Zone'

import CercaMappa from '../../../images/icons/CercaMappa'
import CercaZona from '../../../images/icons/CercaZona'
import IconApp from '../../../images/svg/icon_button_appuntamento.svg'
import IconSite from '../../../images/svg/icon_button_sito.svg'
import ALogoRight from '../../../images/svg/A_chiaro.svg'

import format from '../../../utils/format'
import moment from 'moment'
import 'moment/locale/it'

import copy from '../../../constants/copy.json'

const ProjectPage = ({ classes, project, gallery, isPreview, ...props }) => {

    const contactRef = React.useRef();

    const theme = useTheme();
    const planCarouselDots = useMediaQuery(theme.breakpoints.down('sm'));

    const residenzeList = props.pageContext && props.pageContext.otherProducts;

    const residenza = isPreview ? project : (props.pageContext && props.pageContext.product);

    const mapadoreApp = residenza.acfResidenza.booking && residenza.acfResidenza.groupId && residenza.acfResidenza.projname && residenza.acfResidenza.buildingId && residenza.acfResidenza.soldout !== 'soldOut';

    const zoneRes = (residenza.acfResidenza.zone !== "italia" && residenza.acfResidenza.zone !== "hinterland") ? zones.find((z) => z.zone.includes(residenza.acfResidenza.zone)) : residenza.acfResidenza.zone;

    const otherRes = residenzeList ? residenzeList.filter((item) => {
        if (item.acfResidenza.soldout === 'soldOut') {
            return false;
        }
        const zoneItem = (item.acfResidenza.zone !== "italia" && item.acfResidenza.zone !== "hinterland") ? zones.find((z) => z.zone.includes(item.acfResidenza.zone)).code : item.acfResidenza.zone;

        return item.id !== residenza.id && (zoneItem === zoneRes || zoneItem === zoneRes.code);
    }) : [];


    otherRes.sort((a, b) => {
        if (a.acfResidenza.rating === b.acfResidenza.rating) {
            return b.acfResidenza.price - a.acfResidenza.price;
        }
        return a.acfResidenza.rating - b.acfResidenza.rating;
    });

    const populateResCards = (visibleElements) => {
        const list = otherRes.map((item, idx) => {
            return (
                <ProjectCard
                    item={item}
                    key={idx}
                    last={visibleElements % 2 !== 0 ? idx === visibleElements - 1 : idx >= visibleElements - 2} />
            );
        });
        return list.slice(0, visibleElements);
    };

    const appTypeList = (list) => {
        return (
            (list || []).map((item, idx) => (
                <span style={{ textAlign: 'left', margin: '0px 16px 0px 0px'}}>
                    {item + " "}
                </span>
            ))
        );
    };

    const sortPlanimetrie  = (a,b) => {
        const typeA = (a.caption||"").split(" ")[0];
        const typeB = (b.caption||"").split(" ")[0];

        return aptType[typeA] - aptType[typeB];
    };

    return (
        <div style={{ height: "100%" }}>
            {!isPreview && <Header home={false} />}
            <div className={`${classes.mobileHidden} ${isPreview ? classes.heroContainerPreview : classes.heroContainer}`}>
                <Grid container style={{ height: '100%' }}>
                    <Grid container item xs={3} style={{ height: '100%', zIndex: '2', boxShadow: '#808080 0px 0px 25px 0px' }}>
                        <Grid container style={{height:'35%'}} className={classes.logoBoxContainer} justify='center'>
                            <img className={classes.logo} src={residenza.acfResidenza.logo && residenza.acfResidenza.logo.sourceUrl} alt='' />
                        </Grid>
                        <Grid container style={{height:'65%', flexWrap:'nowrap'}} direction='column' alignItems='center' justify='space-between'>
                            <Grid item className={classes.title}>
                                {residenza.acfResidenza.name}
                            </Grid>
                            <Grid item style={{ fontSize: '6px', margin: '15px', textAlign: 'center' }}>
                                {'\u2B24'}
                            </Grid>
                            <Grid item className={classes.address}>
                                {residenza.acfResidenza.address.streetName}, {residenza.acfResidenza.address.streetNumber}
                            </Grid>
                            <Grid item className={classes.addressCity}>
                                {residenza.acfResidenza.cittaIniziativa ?? residenza.acfResidenza.address.city ?? residenza.acfResidenza.zonedescription}
                            </Grid>
                            <Grid item className={classes.border} />
                            <Grid container item className={classes.circleContainer} alignContent='flex-end' justify='center'>
                                <Grid container item xs={4} justify='center' alignContent='flex-end'>
                                    <Grid container item className={classes.subTitleCircle} justify='center'>
                                        {copy.progetti.projectPage.classe}
                                    </Grid>
                                    <Grid container item className={classes.priceCircle + ' ' + classes.circleFontBig} alignItems='center' justify='center'>
                                        {residenza.acfResidenza.class}
                                    </Grid>
                                </Grid>
                                <Grid container item xs={4} alignContent='flex-end' justify='center'>
                                    <Grid container item className={classes.subTitleCircle} justify='center'>
                                        {(residenza.acfResidenza.zone !== "italia" && residenza.acfResidenza.zone !== "hinterland") ?
                                            (<>
                                                Milano
                                    <Grid item xs={12}>
                                                    {zoneRes.label}
                                                </Grid>
                                            </>)
                                            :
                                            residenza.acfResidenza.zone}
                                    </Grid>
                                    {(residenza.acfResidenza.zone !== "italia" && residenza.acfResidenza.zone !== "hinterland") ?
                                        <Grid container item className={classes.priceCircle} alignContent='center' justify='center'>
                                            <CercaZona color='black' dimension='50px' zoneId={residenza.acfResidenza.zone} />
                                        </Grid>
                                        :
                                        <Grid container item justify='center'>
                                            <CercaMappa black={true} dimension='70px' zoneCode={residenza.acfResidenza.zone} />
                                        </Grid>}
                                </Grid>
                                {!residenza.acfResidenza.hideprice &&
                                    <Grid container item xs={4} justify='center' alignContent='flex-end'>
                                        <Grid container item className={classes.subTitleCircle} justify='center' style={{ textTransform: 'none' }}>
                                            {copy.progetti.projectPage.prezzo}
                                        </Grid>
                                        <Grid container item className={classes.priceCircle} alignItems='center' justify='center' >
                                            {format.currencyFormat(residenza.acfResidenza.price)}<br />
                                        </Grid>
                                    </Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container item xs={9} alignItems='flex-end' className={classes.overflowHidden} style={{position:'relative'}}>
                        <Grid container item className={classes.backgroundImageHero} style={{ backgroundImage: `url(${residenza.acfResidenza.mainimage && residenza.acfResidenza.mainimage.sourceUrl})` }} />
                        <Grid container className={classes.infoContainer} justify='space-between'>
                            <Grid container item xs={3} className={classes.infoSectionContainer}>
                                <h1 style={{ lineHeight: '0', marginBottom: '0' }}>
                                    <span className={classes.subTitleInfo}>
                                        {copy.progetti.projectPage.zona}
                                    </span>
                                    <br />
                                    <span className={classes.infoBold}>
                                        {residenza.acfResidenza.zonedescription}
                                    </span>
                                </h1>
                            </Grid>
                            <Grid container item xs={2} className={classes.infoSectionContainer}>
                                <Grid container item className={classes.subTitleInfo}>
                                    {copy.progetti.projectPage.appartamenti}
                                </Grid>
                                <Grid container item className={classes.infoBold}>
                                    {residenza.acfResidenza.apartments}
                                </Grid>
                            </Grid>
                            <Grid container item xs={2} className={classes.infoSectionContainer}>
                                <Grid container item className={classes.subTitleInfo}>
                                    {copy.progetti.projectPage.consegna}
                                </Grid>
                                <Grid container item className={classes.infoBold}>
                                    {moment(residenza.acfResidenza.available, "YYYY-MM-DD").format("MMMM YYYY")}
                                </Grid>
                            </Grid>
                            {residenza.acfResidenza.soldout === 'boxOnly' &&
                                <Grid container item xs={5} className={classes.infoBoxSectionContainer}>
                                    <Grid container className={classes.boxInfo}>
                                        <Grid container item className={classes.subTitleInfo}>
                                            {copy.progetti.projectPage.boxOnly.bannerTitle}
                                        </Grid>
                                        <Grid container item className={classes.infoBold}>
                                            {copy.progetti.projectPage.boxOnly.bannerSubtitle}
                                        </Grid>
                                    </Grid>
                                </Grid>}
                            {residenza.acfResidenza.soldout === 'soldOut' &&
                                <Grid container item xs={5} className={classes.infoBoxSectionContainer}>
                                    <Grid container className={classes.boxInfo}>
                                        <Grid container item className={classes.subTitleInfo}>
                                            {copy.progetti.projectPage.boxOnly.bannerTitle}
                                        </Grid>
                                        <Grid container item className={classes.infoBold}>
                                            {copy.progetti.projectPage.soldOut.soldOut}
                                        </Grid>
                                    </Grid>
                                </Grid>}
                            {residenza.acfResidenza.soldout === 'available' &&
                                <Grid container item xs={5} className={classes.infoSectionContainer + ' ' + classes.lastSection}>
                                    <h2 style={{ lineHeight: '0', marginBottom: '0' }}>
                                        <span className={classes.subTitleInfo}>
                                            {residenza.acfResidenza.labelavailableapt ? residenza.acfResidenza.labelavailableapt : copy.progetti.projectPage.availableApartment}
                                        </span>
                                        <br />
                                        <span className={classes.infoBold}>
                                            {appTypeList(residenza.acfResidenza.apartmentstype)}
                                        </span>
                                    </h2>
                                </Grid>}
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <div className={classes.heroContainer + ' ' + classes.mobileShow}>
                <Grid container item xs={12} className={classes.backgroundImageHero} style={{ backgroundImage: `url(${residenza.acfResidenza.mainimage && residenza.acfResidenza.mainimage.sourceUrl})` }} />
            </div>
            <div className={classes.mobileShow}>
                <Grid container style={{ height: '100%' }}>
                    <Grid container item xs={12} style={{ zIndex: '2', boxShadow: '#808080 0px 0px 25px 0px' }}>
                        <Grid container className={classes.logoBoxContainer} justify='center'>
                            <img className={classes.logoMobile} src={residenza.acfResidenza.logo && residenza.acfResidenza.logo.sourceUrl} alt='' />
                        </Grid>
                        <Grid container direction='column' alignItems='center' justify='space-between'>
                            <Grid item className={classes.title}>
                                {residenza.acfResidenza.name}
                            </Grid>
                            <Grid item className={classes.address}>
                                {residenza.acfResidenza.address.streetName}, {residenza.acfResidenza.address.streetNumber}
                            </Grid>
                            <Grid item className={classes.addressCity}>
                                {residenza.acfResidenza.cittaIniziativa ?? residenza.acfResidenza.address.city ?? residenza.acfResidenza.zonedescription}
                            </Grid>
                            <Grid item style={{ fontSize: '6px', margin: '15px', textAlign: 'center' }}>
                                {'\u2B24'}
                            </Grid>
                            <Grid container item className={classes.circleContainer} alignContent='flex-end' justify='center'>
                                <Grid container item xs={4} justify='center' alignContent='flex-end'>
                                    <Grid container item className={classes.subTitleCircle} justify='center'>
                                        {copy.progetti.projectPage.classe}
                                    </Grid>
                                    <Grid container item className={classes.priceCircle + ' ' + classes.circleFontBig} alignItems='center' justify='center'>
                                        {residenza.acfResidenza.class}
                                    </Grid>
                                </Grid>
                                <Grid container item xs={4} alignContent='flex-end' justify='center'>
                                    <Grid container item className={classes.subTitleCircle} justify='center'>
                                        {(residenza.acfResidenza.zone !== "italia" && residenza.acfResidenza.zone !== "hinterland") ?
                                            (<>
                                                Milano
                                    <Grid item xs={12}>
                                                    {zoneRes.label}
                                                </Grid>
                                            </>)
                                            :
                                            residenza.acfResidenza.zone}
                                    </Grid>
                                    {(residenza.acfResidenza.zone !== "italia" && residenza.acfResidenza.zone !== "hinterland") ?
                                        <Grid container item className={classes.priceCircle} alignContent='center' justify='center'>
                                            <CercaZona color='black' dimension='50px' zoneId={residenza.acfResidenza.zone} />
                                        </Grid>
                                        :
                                        <Grid container item justify='center'>
                                            <CercaMappa black={true} dimension='70px' zoneCode={residenza.acfResidenza.zone} />
                                        </Grid>}
                                </Grid>
                                {!residenza.acfResidenza.hideprice &&
                                    <Grid container item xs={4} justify='center' alignContent='flex-end'>
                                        <Grid container item className={classes.subTitleCircle} justify='center' style={{ textTransform: 'none' }}>
                                            {copy.progetti.projectPage.prezzo}
                                        </Grid>
                                        <Grid container item className={classes.priceCircle} alignItems='center' justify='center'>
                                            {format.currencyFormat(residenza.acfResidenza.price)}
                                        </Grid>
                                    </Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} alignItems='flex-end'>
                        <Grid container className={classes.infoContainer} justify='space-between'>
                            <Grid container item xs={6} md={3} className={classes.infoSectionContainer}>
                                <h1 style={{ lineHeight: '0', marginBottom: '0' }}>
                                    <span className={classes.subTitleInfo}>
                                        {copy.progetti.projectPage.zona}
                                    </span>
                                    <br />
                                    <span className={classes.infoBold}>
                                        {residenza.acfResidenza.zonedescription}
                                    </span>
                                </h1>
                            </Grid>
                            <Grid container item xs={6} md={2} className={classes.infoSectionContainer}>
                                <Grid container item className={classes.subTitleInfo}>
                                    {copy.progetti.projectPage.appartamenti}
                                </Grid>
                                <Grid container item className={classes.infoBold}>
                                    {residenza.acfResidenza.apartments}
                                </Grid>
                            </Grid>
                            <Grid container item xs={6} md={2} className={classes.infoSectionContainer}>
                                <Grid container item className={classes.subTitleInfo}>
                                    {copy.progetti.projectPage.consegna}
                                </Grid>
                                <Grid container item className={classes.infoBold}>
                                    {moment(residenza.acfResidenza.available, "YYYY-MM-DD").format("MMMM YYYY")}
                                </Grid>
                            </Grid>
                            {residenza.acfResidenza.soldout === 'boxOnly' &&
                                <Grid container item xs={12} md={5} className={classes.infoBoxSectionContainer}>
                                    <Grid container className={classes.boxInfo}>
                                        <Grid container item className={classes.subTitleInfo}>
                                            {copy.progetti.projectPage.boxOnly.bannerTitle}
                                        </Grid>
                                        <Grid container item className={classes.infoBold}>
                                            {copy.progetti.projectPage.boxOnly.bannerSubtitle}
                                        </Grid>
                                    </Grid>
                                </Grid>}
                            {residenza.acfResidenza.soldout === 'soldOut' &&
                                <Grid container item xs={12} md={5} className={classes.infoBoxSectionContainer}>
                                    <Grid container className={classes.boxInfo}>
                                        <Grid container item className={classes.subTitleInfo}>
                                            {copy.progetti.projectPage.boxOnly.bannerTitle}
                                        </Grid>
                                        <Grid container item className={classes.infoBold}>
                                            {copy.progetti.projectPage.soldOut.soldOut}
                                        </Grid>
                                    </Grid>
                                </Grid>}
                            {residenza.acfResidenza.soldout === 'available' &&
                                <Grid container item xs={12} md={5} className={classes.infoSectionContainer + ' ' + classes.lastSection}>
                                    <h2 style={{ lineHeight: '0', marginBottom: '0' }}>
                                        <span className={classes.subTitleInfo}>
                                            {residenza.acfResidenza.labelavailableapt ? residenza.acfResidenza.labelavailableapt : copy.progetti.projectPage.availableApartment}
                                        </span>
                                        <br />
                                        <span className={classes.infoBold}>
                                            {appTypeList(residenza.acfResidenza.apartmentstype)}
                                        </span>
                                    </h2>
                                </Grid>}
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <Grid container>
                {residenza.acfResidenza.booking && !isPreview && residenza.acfResidenza.soldout !== 'soldOut' &&
                    <Grid container className={classes.appointment} alignItems='center' justify='center'>
                        <Button classes={{ root: `${classes.greyButtonDark}` }} onClick={() => contactRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })}>
                            {residenza.acfResidenza.soldout === 'boxOnly' ? copy.progetti.projectPage.appuntamentoCtaBox : copy.progetti.projectPage.appuntamentoCta}
                            <img src={IconApp} alt='' style={{ height: '20px', width: '20px', margin: 'auto', marginLeft: '10px' }} />
                        </Button>
                    </Grid>}
                <Grid container className={classes.carouselContainer} direction='row'>
                    <Grid container item xs={12} md={7} style={{alignItems: 'center', position: 'relative'}}>
                        <GalleryCarousel
                            type='galleryProject'
                            centerMode={false}
                            data={residenza.gallery}
                            dots={true}
                            arrowColor='white'
                            arrowPos='2%' />
                        <div className={classes.letterBackground}>
                            <img src={ALogoRight} />
                        </div>
                    </Grid>
                    <Grid container item xs={12} md={5} direction='column' className={classes.infoContainerCarousel} alignItems='center' justify='space-between'>
                        <Grid container direction='column' alignItems='center'>
                            <Grid container item className={classes.titleCarousel} justify='center'>
                                {residenza.acfResidenza.soldout === 'available' ?
                                    (residenza.acfResidenza.title ? residenza.acfResidenza.title : copy.progetti.projectPage[residenza.acfResidenza.soldout].title)
                                    : copy.progetti.projectPage[residenza.acfResidenza.soldout].title}
                            </Grid>
                            <Grid container item className={classes.subTitleCarousel} justify='center'>
                                {residenza.acfResidenza.soldout !== 'available' ?
                                    copy.progetti.projectPage[residenza.acfResidenza.soldout].subTitle
                                    :
                                    residenza.acfResidenza.description}
                            </Grid>
                            {residenza.acfResidenza.soldout === 'available' &&
                                <>
                                    <Grid item className={classes.borderCarousel} />
                                    <Grid className={classes.description}>
                                        {residenza.acfResidenza.subdescription}
                                    </Grid>
                                </>
                            }
                            {residenza.acfResidenza.soldout === 'boxOnly' &&
                                <>
                                    <Grid item className={classes.borderCarousel} />
                                    <Grid className={classes.description}>
                                        {copy.progetti.projectPage[residenza.acfResidenza.soldout].description}
                                    </Grid>
                                </>
                            }
                        </Grid>
                        {residenza.acfResidenza.soldout !== 'soldOut' && residenza.acfResidenza.siteurl &&
                            <Grid className={classes.siteButtonContainer}>
                                <Button classes={{ root: classes.greyButtonDark }} onClick={() => window.open(residenza.acfResidenza.siteurl, '_blank')}>
                                    {copy.progetti.projectPage.cta}
                                    <img src={IconSite} alt='' style={{ height: '20px', width: '20px', margin: 'auto', marginLeft: '10px' }} />
                                </Button>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                {residenza.acfResidenza.soldout === 'available' && residenza.planimetrie.length > 0 &&
                    <>
                        <Grid container className={`${classes.mobileShow}`}>
                            <Grid container justify='center' style={{margin: '0px 20px 50px 20px'}}>
                                <Divider className={classes.divider} />
                            </Grid>
                        </Grid>
                        <Grid container className={classes.planContainer}>
                            <Grid container alignContent='center' alignItems='center' justify='center' className={classes.sectionTitle} />
                            <GalleryCarousel
                                type='planProject'
                                centerMode={false}
                                data={residenza.planimetrie.sort(sortPlanimetrie)}
                                dots={planCarouselDots}
                                arrowColor='black'
                                arrowPos='-6%' />
                        </Grid>
                    </>}
                {!isPreview && residenza.acfResidenza.soldout !== 'soldOut' &&
                    <RootRef rootRef={contactRef}>
                        {mapadoreApp ?
                            <ContactProject residenza={residenza} />
                            :
                            <Contact residenza={residenza} />}
                    </RootRef>}
                {residenza.acfResidenza.video &&
                    <Grid container justify='center' className={classes.videoContainer}>
                        <Grid container alignContent='center' alignItems='center' justify='center' className={classes.sectionTitleUnderline + ' ' + classes.separatorMobile}>
                            {copy.progetti.projectPage.valore}
                        </Grid>
                        <Grid container alignContent='center' alignItems='center' justify='center' className={classes.subTitle}>
                            Lasciati ispirare e scopri {residenza.acfResidenza.name} in una esclusiva anteprima
                        </Grid>
                        <Grid container justify='center' className={classes.videoPlayerContainer}>
                            <VideoPlayer
                                title={residenza.acfResidenza.name}
                                src={residenza.acfResidenza.video}
                            />
                        </Grid>
                    </Grid>}
                {!isPreview &&
                    <Grid container item justify='center' className={classes.otherRes}>
                        <Grid container alignContent='center' alignItems='center' justify='center' className={classes.subTitle}>
                            {copy.progetti.projectPage.other}
                        </Grid>
                        <Grid container alignContent='center' alignItems='center' justify='center' className={classes.sectionTitleUnderline}>
                            {(residenza.acfResidenza.zone !== "italia" && residenza.acfResidenza.zone !== "hinterland") ?
                                ('Milano ' + zoneRes.label)
                                :
                                residenza.acfResidenza.zone}
                        </Grid>
                        {otherRes.length > 0 ?
                            <Grid container className={classes.resCardsContainer}>
                                <Pagination
                                    pagination={4}
                                    cta={copy.progetti.otherResCta}
                                    elementNumber={otherRes.length}
                                    elements={otherRes}
                                    populatePage={(visibleElements) => populateResCards(visibleElements)} />
                            </Grid>
                            :
                            <Grid container alignContent='center' alignItems='center' justify='center' className={classes.subTitleNoRes}>
                                {copy.progetti.projectPage.noRes}
                            </Grid>}
                    </Grid>}
                {!isPreview && <NewsLetter zone={(residenza.acfResidenza.zone !== "italia" && residenza.acfResidenza.zone !== "hinterland") ? 'milano' : zoneCards.find((z) => z.zoneCode === residenza.acfResidenza.zone).zoneUrl} />}
            </Grid>
            {!isPreview && <Footer />}
        </div>
    )
}

export default withStyles(projectPageStyle)(ProjectPage)